import Api from '../http.service';

/**get General Item By Type
 * @param {Object} payload
 * @param {Object} payload.data
 * @param {String} payload.data.type
 */
export const getGeneralItemByType = (payload) =>
  Api.POST({
    url: `general_item/type/`,
    data: payload.data,
  });

/**
 * get all general items
 * @param {Object} payload
 * @param {Number} payload.pageNumber
 * @param {Number} payload.itemPerPage
 * @param {Object} payload.data
 * @param {Object} payload.data.sort
 * @param {Object} payload.data.filter
 * @param {String} payload.data.filter.phrase
 * @param {String} payload.data.filter.type
 */
export const getAll = (payload) =>
  Api.POST({
    url: `general_item/all/${payload.pageNumber - 1}/${payload.itemPerPage}`,
    data: payload.data,
  });

/**
 *
 * @param {Object} payload
 * @param {Object} payload.data
 * @param {Object} payload.data.name
 * @param {String} payload.data.name.en
 * @param {String} payload.data.name.fa
 * @param {Object} payload.data.description
 * @param {String} payload.data.description.en
 * @param {String} payload.data.description.fa
 * @param {String} payload.data.type
 * @param {String} payload.data.code
 */
export const insertTemp = (payload) =>
  Api.POST({ url: 'temp_general_item', data: payload });
